
function split ( browserString ) {
  const [ name, version ] = browserString.split( ' ' )
  return {
    name: name.toLowerCase(),
    version: parseInt( version, 10 )
  }
}


function detect() {
  const ua = navigator.userAgent
  let tem

  let M = ua.match( /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i ) || []
  if ( /trident/i.test( M[ 1 ] ) ) {
    tem = /\brv[ :]+(\d+)/g.exec( ua ) || []
    return split( 'IE ' + ( tem[ 1 ] || '' ) )
  }
  if ( M[ 1 ] === 'Chrome' ) {
    tem = ua.match( /\b(OPR|Edge)\/(\d+)/ )
    if ( typeof tem === 'string' ) {
      return tem.slice( 1 ).join( ' ' ).replace( 'OPR', 'Opera' )
    }
  }
  M = M[ 2 ] ? [ M[ 1 ], M[ 2 ] ] : [ navigator.appName, navigator.appVersion, '-?' ]

  // eslint-disable-next-line no-cond-assign
  if ( ( tem = ua.match( /version\/(\d+)/i ) ) !== null ) {
    if ( typeof tem === 'string' ) {
      M.splice( 1, 1, tem[ 1 ] )
    }
  }
  return split( M.join( ' ' ) )
}


const browser = detect()


function addClasses() {
  const { name } = browser
  const doc = document.documentElement
  //document.documentElement.classList.add( name )
  doc.setAttribute( 'class', name )
  if ( name === 'ie' && document.body ) {
    //document.body.classList.add( 'ie' )
    document.body.setAttribute( 'class', 'ie' )
  }
}
// ???
addClasses()



function ieLessThen11() {
  const agent = window.navigator.userAgent
  const reg = /MSIE\s?(\d+)(?:\.(\d+))?/i
  const matches = agent.match( reg )
  if ( matches !== null ) {
    return true
  }
  return false
}




function checkBrowser() {

  const { name, version } = browser
  const ver = typeof version !== 'number' ? 0 : version

  if (
    ( name === 'opera' && ver <= 12 ) ||
    ( name === 'safari' && ver <= 5 ) ||
    ieLessThen11()
  ) {
    return false
  }
  return true

}


export default checkBrowser



// WEBPACK FOOTER //
// ./src/browserCheck/browserCheck.js